import { jwtDecode } from "jwt-decode";

export function isValidJWT(token) {
  if (!token) return false;
  try {
    // Token is already decrypted when stored in localStorage
    const decoded = jwtDecode(token);

    if (!decoded.exp || typeof decoded.exp !== "number") return false;

    return Date.now() < decoded.exp * 1000; // Check if token is still valid
  } catch (error) {
    return false;
  }
}
